module.exports = "https://static.wmbcdn.com/uniweb/images/060ea9e52592703a7a64d259e41f7499.svg";